try {
  exports.livechat = window.livechat;
  exports.LiveChatAvCallTypes = window.LiveChatAvCallTypes;
  exports.LivechatAVLibrarySettings = window.LivechatAVLibrarySettings;
  exports._config = window._config;
  exports.messenger = window.parent.messenger;
} 
catch (error) {
  console.log('Livechat Ref: ', error);
}